export default [
// --- GESTIÓN DE CATEGORÍAS ---
  {
    path: 'categorias',
    name: 'empresa.sucursal.categorias',
    component: () => import('@/views/empresa/sucursales/categorias/SucursalCategoriasHome.vue'),
    meta: { requiresAuth: true, requireSucursal: true, requireSucursalSeleccionada: true },
    redirect: { name: 'empresa.sucursal.categorias.gestion' },
    children: [
      {
        path: 'gestion',
        name: 'empresa.sucursal.categorias.gestion',
        component: () => import('@/views/empresa/sucursales/categorias/SucursalCategoriasGestion.vue'),
      },
      // Aquí podrías agregar en el futuro: path: 'ordenar', path: 'editar-iconos', etc.
    ]
  },
]